// src/app/modules/capitalShare/redux/saga.ts
import {call, put, takeLatest} from 'redux-saga/effects'
import {toast} from 'react-toastify'
import * as constants from './constants'
import * as service from './service'

function* cbsLookupSaga(action: any): any {
  try {
    const response = yield call(service.cbsAccountLookup, action.payload.account_number)
    yield put({type: constants.CS_CBS_LOOKUP_SUCCESS, payload: response.data})
  } catch (e: any) {
    yield put({type: constants.CS_CBS_LOOKUP_FAILURE, payload: e.message})
  }
}

function* fetchListSaga(action: any): any {
  try {
    const response = yield call(service.fetchApplicationList, action.payload)
    const data = response.data?.data?.documents ?? response.data?.data ?? []
    const total = response.data?.data?.meta?.total ?? response.data?.meta?.total ?? 0
    yield put({type: constants.CS_FETCH_LIST_SUCCESS, payload: {data, total}})
  } catch (e: any) {
    yield put({type: constants.CS_FETCH_LIST_FAILURE, payload: e.message})
  }
}

function* submitSaga(action: any): any {
  try {
    const {data, step, onSuccess} = action.payload
    const response = yield call(service.submitApplication, data, step)
    yield put({type: constants.CS_SUBMIT_SUCCESS})
    const caseNo = response.data?.case_no ?? response.data?.resDesc ?? 'Submitted'
    toast.success(`Application submitted. Ref: ${caseNo}`)
    if (onSuccess) onSuccess()
  } catch (e: any) {
    yield put({type: constants.CS_SUBMIT_FAILURE, payload: e.message})
    toast.error(e?.response?.data?.message ?? 'Submission failed. Please try again.')
  }
}

function* fetchCaseSaga(action: any): any {
  try {
    const response = yield call(service.fetchCase, action.payload.case_id)
    yield put({type: constants.CS_FETCH_CASE_SUCCESS, payload: response.data.data})
  } catch (e: any) {
    yield put({type: constants.CS_FETCH_CASE_FAILURE, payload: e.message})
  }
}

function* checkerActionSaga(action: any): any {
  try {
    const {action: act, case_id, remarks, onSuccess} = action.payload
    yield call(service.checkerAction, act, case_id, remarks)
    yield put({type: constants.CS_CHECKER_ACTION_SUCCESS})
    toast.success(`Case ${act}d successfully.`)
    if (onSuccess) onSuccess()
  } catch (e: any) {
    yield put({type: constants.CS_CHECKER_ACTION_FAILURE, payload: e.message})
    toast.error('Action failed. Please try again.')
  }
}

function* fetchFeeConfigSaga(): any {
  try {
    const response = yield call(service.fetchFeeConfig)
    yield put({type: constants.CS_FETCH_FEE_CONFIG_SUCCESS, payload: response.data})
  } catch (e: any) {
    console.error('Fee config fetch error', e)
  }
}

function* updateFeeConfigSaga(action: any): any {
  try {
    const response = yield call(service.updateFeeConfig, action.payload)
    yield put({type: constants.CS_UPDATE_FEE_CONFIG_SUCCESS, payload: response.data})
    toast.success('Fee configuration saved.')
  } catch (e: any) {
    toast.error('Failed to save fee configuration.')
  }
}

export function* saga() {
  yield takeLatest(constants.CS_CBS_LOOKUP_REQUEST, cbsLookupSaga)
  yield takeLatest(constants.CS_FETCH_LIST_REQUEST, fetchListSaga)
  yield takeLatest(constants.CS_SUBMIT_REQUEST, submitSaga)
  yield takeLatest(constants.CS_FETCH_CASE_REQUEST, fetchCaseSaga)
  yield takeLatest(constants.CS_CHECKER_ACTION_REQUEST, checkerActionSaga)
  yield takeLatest(constants.CS_FETCH_FEE_CONFIG_REQUEST, fetchFeeConfigSaga)
  yield takeLatest(constants.CS_UPDATE_FEE_CONFIG_REQUEST, updateFeeConfigSaga)
}
